<template>
  <div class="kpytFhxsc" v-if="kbxmlc">
    <div class="box noBtn">
      <div class="row">
        <div class="clear">
          <p class="cont-title lf">资格符合性审查</p>
          <el-input
              v-model="searchForm.tbdwmc"
              class="input-with-select lf"
              style="width: 200px; margin: 0 10px"
              placeholder="投标单位名称"
              clearable
              @change="getData"
          ></el-input>
          <el-input
              v-model="searchForm.cqbh"
              class="input-with-select lf"
              style="width: 120px; margin: 0 10px 0 0"
              placeholder="抽签编号"
              clearable
              @change="getData"
          ></el-input>
          <el-button
              @click="getData"
              type="primary"
          >查 询</el-button>
        </div>
        <div class="row">
<!--          <el-button-->
<!--              @click="ipCheck"-->
<!--              v-if="role == 'Z'"-->
<!--              type="primary"-->
<!--              :disabled="tableConfig.data.length == 0 || kbxmlc.zt == '2'"-->
<!--          >IP地址查重</el-button>-->
          <el-button @click="lookTbwj" type="primary">查看投标文件</el-button>
          <el-button
            @click="drawCode"
            v-if="role == 'Z'"
            :disabled="isNext"
            type="primary"
            >输入抽取编号</el-button
          >
          <el-button
            @click="draw"
            v-if="role == 'Z'"
            :disabled="isNext"
            type="primary"
            >抽取</el-button
          >
          <el-button type="primary" @click="lookRules" :disabled="waitLoading"
            >查看规则</el-button
          >
        </div>
      </div>
      <p class="red" style="padding-bottom: 10px">
        <span>
          <template>
            {{ csList }}
          </template>
        </span>
      </p>
      <div class="main">
        <table-tem
          ref="table"
          :config="tableConfig"
          :key="tableConfig.key"
          :span-method="objectSpanMethod"
          :highlightCurrentRow="false"
          @changePage="tableChangePage"
          @changePages="changePages"
          :conditionProp="'ipRepeat'"
          :conditionValue="true"
          v-loading="waitLoading"
        >
          <template #indexNum="{ scope }">
            <span>{{ (tableConfig.currentPage - 1) * tableConfig.pageSize + scope.$index + 1 }}</span>
          </template>
          <template #sc="scope">
            <el-select
              v-model="scope.data.complianceReview"
              v-if="kbxmlc.zt != '2' && role == 'Z'"
              class="small"
              placeholder="请选择"
              @change="saveComplianceReview(scope.data)"
            >
              <el-option
                v-for="item in scOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
            <template v-else>{{
              scope.data.complianceReview == 1
                ? "通过"
                : scope.data.complianceReview == 2
                ? "不通过"
                : ""
            }}</template>
          </template>
        </table-tem>
        <!-- <span class="lf pageNum">此次共有{{zgs}}家投标单位，递交投标报价{{}}家</span> -->
      </div>
      <el-button
        v-if="role == 'Z'"
        :disabled="canNext || kbxmlc.zt == '2'"
        @click="bxNextBtn"
        type="primary lcNext"
        >下一步</el-button
      >
    </div>
    <el-dialog
      title="抽取编号"
      :visible.sync="drawDialogShow"
      width="800px"
      :close-on-click-modal="false"
      @close="closeDrawDialog"
    >
      <div class="history-layout" v-if="drawHistory.length > 0">
        <p>历史抽取编号</p>
        <div class="history-layout-list">
          <div class="text" v-for="(item, index) in drawHistory" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="draw-layout">
        <p>抽取编号</p>
        <div class="draw-box">
          <el-input
            v-for="(item, index) in drawInput"
            :key="index"
            class="input"
            v-model="item.value"
            placeholder="请输入抽取编号"
          ></el-input>
          <div class="btn" @click="delInput">-</div>
          <div class="btn" @click="addInput">+</div>
        </div>
      </div>
      <div class="tips">
        温馨提示：确定前请务必核对仔细输入的抽取编号！确定后不可修改！
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="submitDraw">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="查看规则"
      :visible.sync="showRules"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="rules">
        <p>{{ rules }}</p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="showRules = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>

  <script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  components: {
    tableTem,
  },
  computed: {
    role() {
      return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
    },
    isNext() {
      return this.kbxmlc.zt == 2;
    },
  },
  data() {
    return {
      waitLoading: false,
      djlcId: "", //节点流程id
      tbdwmc: "",
      kcxm: {},
      kbxmlc: {},
      csList: "",
      tableConfig: {
        head: [],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
        height: 500,
        noDataText: "请从投标单位中抽取投标单位，进行资格审查！",
        key: 1,
        className: 'is-repeat'
      },
      scOptions: [
        { label: "请选择", id: "0" },
        { label: "通过", id: "1" },
        { label: "不通过", id: "2" },
      ],
      options: [
        {
          value: 1,
          label: "按投标单位审查",
        },
        {
          value: 2,
          label: "按分项审查",
        },
      ],
      tjzbhxr: null,
      tableData: [],
      number: [],
      dialogVisible: false,
      drawDialogShow: false,
      candidate: null,
      candidateOptions: [],
      showRules: false,
      fhxscIds: [],
      rules: "",
      drawListen: null,
      total: 0,
      drawInput: [{ value: "" }],
      drawHistory: [],
      canNext: true,
      searchForm: {
        tbdwmc: "",
        cqbh: "",
      }
    };
  },
  created() {
    this.djlcId = this.$route.query.djlcId;
    this.tjzbhxr = 1;
    // this.fhxscIds = JSON.parse(sessionStorage.getItem("myParam")) || [];
    this.total = sessionStorage.getItem("FhxscTotal") || 0;
    this.getData();
  },
  methods: {
    handleNoText() {
      console.log(localStorage.getItem("role"));
      let role = localStorage.getItem("role");
      if (role == "A") {
        // 招标代理
        this.tableConfig.noDataText = "待主持人抽取投标单位后，进行审查";
      } else {
        // 主持人
        this.tableConfig.noDataText = `请从${this.tableConfig.total}家投标单位中抽取投标单位，进行资格审查！`;
      }
    },
    closeDrawDialog() {
      this.drawInput = [{ value: "" }];
      this.drawDialogShow = false;
    },
    async checkNext() {
      try {
        const res = await this.$api.checkfhxsc();
        if (res.data.success) {
          this.canNext = !res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async submitDraw() {
      let arr = this.drawInput.map((el) => {
        return el.value;
      });
      try {
        let params = {
          pms: arr,
        };
        const res = await this.$api.saveExtractNum(params);
        if (res.data.success) {
          this.closeDrawDialog();
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    delInput() {
      if (this.drawInput.length == 1) return;
      this.drawInput.pop();
    },
    addInput() {
      this.drawInput.push({ value: "" });
    },
    drawCode() {
      this.drawDialogShow = true;
    },
    draw() {
      // 打开新标签 并且监听新标签抽中的参数
      console.log(this.formItem);
      let _this = this;
      let url = `/fhxscDraw?len=${this.total}`;
      window.open(url, "_blank");
      // 定义事件处理函数
      function storageEventListener(event) {
        if (event.key === "myParam" && event.newValue !== null) {
          // 从新标签页传递回来的参数
          const param = JSON.parse(event.newValue);
          param.result[0].jg.forEach((el) => {
            _this.fhxscIds.push(el);
          });
          _this.fhxscIds = [...new Set(_this.fhxscIds)];
          _this.saveExtractNum(param.result[0].jg);
          _this.getData();
          // sessionStorage.setItem("myParam", JSON.stringify(_this.fhxscIds));
          // 删除事件监听器
          window.removeEventListener("storage", storageEventListener);
        }
      }

      // 添加事件监听器
      window.addEventListener("storage", storageEventListener);
    },
    async saveExtractNum(data) {
      try {
        let params = {
          pms: data,
        };
        const res = await this.$api.saveExtractNum(params);
      } catch (error) {
        this.$message.error(error);
      }
    },
    lookTbwj() {
      let { href } = this.$router.resolve({ name: "newLookTbwj" });
      window.open(href, "_blank");
    },
    async lookRules() {
      let res = await this.$api.lookRule();
      if (res.data.success) {
        this.rules = res.data.data;
        this.showRules = true;
      }
    },
    async saveComplianceReview(row) {
      try {
        let para = {
          djlcId: this.djlcId,
          jgdm: row.entCode,
          zgsczt: row.complianceReview,
          updateCandidate: row.complianceReview == "1" ? true : false,
        };
        this.waitLoading = true;
        let res = await this.$api.saveZgsc(para);
        if (res.status == 200) {
          this.checkNext();
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    changeData(secondaryName, threeLevelName) {
      this.tableConfig.data = [];
      this.number = [];
      this.companyFlag = false;
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          k[threeLevelName].map((p, index) => {
            k[p.bjcsId] = p.csznr;
          });
        });
      }
      for (const v of this.tableData) {
        v[secondaryName].map((k, index) => {
          let param = {
            ...v,
            qdmc: this.tjzbhxr == 1 ? k.qdmc : v.qdmc,
            qymc: this.tjzbhxr == 1 ? v.qymc : k.qymc,
            ...k
          };
          this.tableConfig.data.push(param);
        });
      }
      for (let i = 0; i < this.tableData.length; i++) {
        this.number.push({
          qdmc: this.tableData[i].qdmc,
          num: this.tableData[i][secondaryName].length,
        });
      }
      let msgIndex = 0;
      let msgArr = [];
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        msgIndex += num;
        msgArr.push(msgIndex);
      }
      msgArr.pop();
      msgArr.unshift(0);
      for (let i = 0; i < this.number.length; i++) {
        let num = this.number[i].num;
        this.tableConfig.data[msgArr[i]].rowspan = num;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 如果是前两列，就使用idIndex数据来进行合并
      if (this.tjzbhxr == 1) {
        if ([0, 1, 2].includes(columnIndex) || column.label == "抽签编号" || column.label == "审查" || column.label == "IP地址" || column.label == "备注") {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      } else {
        if (columnIndex <= 2) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
      }
    },
    tjzbhxrChange(index) {
      this.tjzbhxr = index;
      this.$refs.table.$refs.tableTem.clearSelection();
      this.getData();
    },
    getData(data) {
      this.once();
      this.candidate = null;
      let pms = this.fhxscIds.join(",");
      let para = {
        tbdwmc: this.searchForm.tbdwmc,
        cqbh: this.searchForm.cqbh,
        pms: pms,
        djlcId: this.djlcId,
        currentPage: this.tableConfig.currentPage,
        type: this.tjzbhxr,
        pageSize: this.tableConfig.pageSize,
      };
      para = Object.assign(para, data);
      this.waitLoading = true;
      this.$api
        .kpytfhxscList(para)
        .then((res) => {
          if (res.data.meta.success) {
            if (pms == "") {
              this.total = res.data.data.tbdwList.total;
              sessionStorage.setItem("FhxscTotal", this.total);
            }
            this.tableConfig.total = res.data.data.tbdwList.total;
            this.kbxmlc = res.data.data.kbxmlc;
            this.kbxm = res.data.data.kbxm;
            this.csList = res.data.data.csList;
            if (this.kbxm?.pms) {
              this.drawHistory = this.kbxm?.pms.split(",");
            }
            this.handleNoText();
            this.checkNext();
            if (this.fhxscIds.length !== 0 || this.isNext) {
              let cgTbbjCsList = res.data.data.cgTbbjCsList || [];
              cgTbbjCsList.map((item, index) => {
                this.tableConfig.head.splice(3 + index, 0, {
                  key: item.id,
                  title:
                    item.cszmc + (item.bjlxdw ? "(" + item.bjlxdw + ")" : ""),
                  align: "center",
                });
              });
              this.tableConfig.key++
              res.data.data.tbdwList.list.forEach((item, index) => {
                item.indexNum = (this.tableConfig.currentPage - 1) * this.tableConfig.pageSize + index + 1;
              })
              this.tableData = res.data.data.tbdwList.list;
              this.changeData("tbdwQdTbdwResultList", "tbdwCsTbdwResultList");
            }
            if (this.drawHistory.length > 0 && pms != this.kbxm.pms) {
              this.fhxscIds = this.drawHistory;
              this.getData({ pms: this.kbxm.pms });
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    ipCheck() {
      try {
        this.$api.checkIpRepeat().then( res=> {
          if (res.data.msg.includes("有")) {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          } else {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          }
          this.getData()
        })
      } catch (e) {
        console.log(e)
      }
    },
    once() {
      this.tableConfig.head = [
        {
          type: "selection",
          width: 40,
          fixed: 'left'
        },
        {
          key: "indexNum",
          title: "序号",
          align: "center",
          width: 60,
          fixed: 'left'
        },
        {
          key: "qymc",
          title: "投标单位名称",
          align: "center",
          width: 200,
          fixed: 'left'
        },
        {
          key: "pm",
          title: "抽签编号",
          align: "center",
        },
        // {
        //   key: "uploadIp",
        //   title: "IP地址",
        //   align: "center",
        // },
        {
          key: "remark",
          title: "备注",
          align: "center",
          width: 120,
        },
        {
          type: "slot",
          title: "审查",
          align: "center",
          slotName: "sc",
          width: 120,
          fixed: 'right'
        },
      ];
    },
    dialogShow() {
      console.log(this.$refs.table.checkList);
      const list = this.$refs.table.checkList;
      if (list.length == 1) {
        this.dialogVisible = true;
      } else {
        this.$message.warning("请勾选1家投标单位");
      }
    },
    bxNextBtn() {
      this.$confirm(
        "请确认是否提交数据并进入下一步，确认后评审结果不可修改",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let para = {
            flag: this.kbxmlc.ycdz,
          };
          this.waitLoading = true;
          this.$emit("nextBtn", para);
        })
        .catch(() => {});
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>

  <style lang='scss' scoped>
.noBtn {
  display: flex;
  flex-direction: column;
}
.main {
  .main-top {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    .main-top-left {
      margin-bottom: 10px;
      label {
        margin-right: 20px;
      }
    }
  }
  .rightButton {
    position: absolute;
    right: 10px;
    top: 60px;
  }
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.clear {
  clear: initial !important;
}
.pageNum {
  position: relative;
  bottom: 50px;
}
.history-layout {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  p {
    margin-right: 20px;
  }
  .history-layout-list{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    .text {
      margin-right: 20px;
    }
  }
}
.draw-layout {
  display: flex;
  align-items: center;
  p {
    width: 70px;
  }
  .draw-box {
    width: 800px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .input {
    width: 150px;
    margin: 0 8px 8px 8px;
  }
  .btn {
    width: 40px;
    height: 25px;
    background: #d70a30;
    text-align: center;
    line-height: 25px;
    margin: 0 8px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 8px 8px 8px;
  }
}
.tips {
  font-size: 16px;
  color: coral;
  margin: 20px 0;
  text-align: center;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: white;
}
</style>
